"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.version = exports.versionInfo = exports.getDDFCsvReaderObject = exports.DdfCsvError = exports.FrontendFileReader = void 0;
const frontend_file_reader_1 = require("./file-readers/frontend-file-reader");
var frontend_file_reader_2 = require("./file-readers/frontend-file-reader");
Object.defineProperty(exports, "FrontendFileReader", { enumerable: true, get: function () { return frontend_file_reader_2.FrontendFileReader; } });
var ddfcsv_error_1 = require("./ddfcsv-error");
Object.defineProperty(exports, "DdfCsvError", { enumerable: true, get: function () { return ddfcsv_error_1.DdfCsvError; } });
const ddfcsv_reader_1 = require("./ddfcsv-reader");
exports.getDDFCsvReaderObject = (0, ddfcsv_reader_1.prepareDDFCsvReaderObject)(new frontend_file_reader_1.FrontendFileReader());
const __VERSION = '4.5.1';
const __BUILD = '1725027750257';
const __PACKAGE_JSON_FIELDS = {"name":"@vizabi/reader-ddfcsv","description":"Vizabi DDFcsv reader"};
exports.versionInfo = { version: __VERSION, build: __BUILD, package: __PACKAGE_JSON_FIELDS };
exports.version = __VERSION;
//# sourceMappingURL=index-web.js.map